module.exports = __webpack_public_path__ + "img/motor_no29.aa5da4f9.jpg";